import React, { useEffect } from "react";
import "./FounderSection.css";
import founderImg from "../../assets/images/founder-img.jpg";

const FounderSection = () => {
  useEffect(() => {
    const items = document.querySelectorAll(".reveal");

    const onScroll = () => {
      items.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight - 150) {
          el.classList.add("show");
          el.classList.add("revealed-once");
        }
      });
    };

    window.addEventListener("scroll", onScroll);
    onScroll();

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <section className="founder-wrapper reveal">

      <div className="founder-container">

        {/* LEFT IMAGE */}
        <div className="founder-left">
          <div className="img-box">
            <img src={founderImg} alt="Founder" />
          </div>

          <div className="founder-info-card">
            <h3>Mr. Navnath Mohan Darekar</h3>
            <p>Founder & CEO</p>
            <span>NMD Infotech Services</span>
          </div>
        </div>

        {/* RIGHT TEXT */}
        <div className="founder-right">
          <h2 className="founder-title">MEET OUR FOUNDER</h2>

          {/* Scrolling line under heading */}
          <div className="founder-scroll-line reveal"></div>

          <p>Mr. Navanath Mohan Darekar globally known as NMD.</p>
          <p>
            Mr. Navnath Darekar is a visionary entrepreneur and the driving force behind NMD Infotech Services. With a strong foundation in software engineering and deep expertise in cloud computing, he founded NMD Infotech with the mission of delivering powerful yet practical digital solutions for businesses.
          </p>

          <p>
            Over the years, he has successfully led the company to execute <b>50+ IT projects</b>, ranging from mobile apps to AI analytics systems. His technical acumen and leadership skills have helped the company build a reputation for innovation and reliability. 
          </p>

          <p>
            Mr. Navnath Darekar is also a mentor to young developers and an active participant in various tech forums and events. His philosophy revolves around building solutions that not only solve business problems but also create long-term value. He believes in empowering his team with knowledge, encouraging collaboration, and staying ahead of industry trends.
          </p>

          <blockquote className="quote">
            “We build software not just for functionality, but for transformation.”
            <span>– Navnath Darekar</span>
          </blockquote>
        </div>

      </div>

    </section>
  );
};

export default FounderSection;
